import React from 'react';
import ObservationCard from '../../../components/common/ObservationCard/ObservationCard';
import observationStyles from '../../../components/common/ObservationCard/ObservationCard.module.css';
import {
  PUBLIC_ANAMNESE_OBSERVATIONS,
  type PublicAnamneseObservationKey,
} from './publicAnamnese.constants';
import formStyles from './PublicAnamneseForm.module.css';

interface AnamneseObservationProps {
  observationKey: PublicAnamneseObservationKey;
  className?: string;
  visible?: boolean;
}

const AnamneseObservation: React.FC<AnamneseObservationProps> = ({
  observationKey,
  className = formStyles.feedbackField,
  visible = true,
}) => {
  const observation = PUBLIC_ANAMNESE_OBSERVATIONS[observationKey];

  return (
    <ObservationCard bordered={observation.bordered} className={className} visible={visible}>
      {observation.blocks.map((block, blockIndex) => (
        <div
          key={`${observationKey}-block-${blockIndex}`}
          className={blockIndex > 0 ? observationStyles.blockSpacing : undefined}
        >
          {block.paragraphs?.map((paragraph, paragraphIndex) => (
            <ObservationCard.Text key={`${observationKey}-paragraph-${paragraphIndex}`}>
              {paragraph}
            </ObservationCard.Text>
          ))}

          {'listItems' in block && block.listItems && block.listItems.length > 0 ? (
            <ul className={observationStyles.list}>
              {block.listItems.map((item, itemIndex) => (
                <li key={`${observationKey}-item-${itemIndex}`} className={observationStyles.listItem}>
                  {item}
                </li>
              ))}
            </ul>
          ) : null}

          {'attention' in block && block.attention ? (
            <ObservationCard.Text>
              <ObservationCard.Highlight>ATENÇÃO:</ObservationCard.Highlight>
              {' '}
              {block.attention.replace(/^ATENÇÃO:\s*/i, '')}
            </ObservationCard.Text>
          ) : null}
        </div>
      ))}
    </ObservationCard>
  );
};

export default AnamneseObservation;
